import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";
import { hasAtLeast } from "../auth/session";

/**
 * Refuses a route to non-admins.
 *
 * The sidebar already hides Settings from non-admins (AdminOnly), but §3.4 is
 * explicit that hiding is not the control — a viewer who types the URL must
 * still be turned away. In the real app the settings /api routes enforce this
 * server side too; this is the client half of "do both".
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { appRole } = useAuth();
  if (!hasAtLeast(appRole, "admin")) {
    return (
      <div className="grid min-h-[60vh] place-items-center p-4 text-center">
        <div>
          <h1 className="text-display-xs font-semibold text-gray-900">Admins only</h1>
          <p className="mt-2 text-sm text-[var(--text-2)]">
            Settings are limited to CE admins. Ask your administrator if you need access.
          </p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
